import { render, staticRenderFns } from "./TS04.vue?vue&type=template&id=79147c4e&scoped=true&"
import script from "./TS04.vue?vue&type=script&lang=js&"
export * from "./TS04.vue?vue&type=script&lang=js&"
import style0 from "./TS04.vue?vue&type=style&index=0&id=79147c4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79147c4e",
  null
  
)

export default component.exports